import { TextFieldTheme } from '@wix/wix-ui-tpa/cssVars';
import classNames from 'classnames';
import React, { useCallback, useEffect, useState } from 'react';
import { useSubmitSuccessEvent } from '../../contexts/events-context';
import { ForcedState, useForcedState } from '../../contexts/forced-state-context';
import { useTranslation } from '../../contexts/translation-context';
import { useFieldAttributes } from '../../services/field-attributes';
import { FieldDescriptionWUT } from '../field-description/field-description-wut';
import { FieldErrorWUT } from '../field-error/field-error-wut';
import { FieldLabelWUT } from '../field-label/field-label-wut';
import { useInvokeCallback } from '../shared/use-invoke-callback';
import { Widget } from '../widget/widget';
import { parseCountryCodeFromCallingCode, parseLocalPhone } from './phone-input/phone-input-utils';
import { PhoneInputWUT } from './phone-input/phone-input-wut';
import { classes } from './phone-input-field-wut.st.css';
export const PhoneInputFieldWUT = ({ id, target, label, hideLabel = false, placeholder, required = false, description, value = '', defaultCountry, showFlag, validation, onChange: _onChange, onBlur, onFocus, error, disabled = false, hasError = false, errorMessage, FieldLayout, requiredIndicatorType, requiredIndicatorPlacement, readOnly, defaultValue, widgetHtml, widgetEnabled })=>{
    const { t } = useTranslation();
    const { labelId, inputId, errorId, descriptionId, ariaDescribedBy } = useFieldAttributes(id, error, description);
    const allowedCountryCodes = validation?.string?.phoneOptions?.allowedCountryCodes;
    const getInitialCurrentValue = ()=>{
        // TODO: remove when defaultValue is removed from schema
        if (defaultValue === value && defaultValue.length <= 4 && !!parseCountryCodeFromCallingCode(defaultValue)) {
            return '';
        }
        return value;
    };
    const [currentValue, setCurrentValue] = useState(getInitialCurrentValue);
    const forcedHover = useForcedState().includes(ForcedState.INPUT_FIELDS_HOVER);
    useEffect(()=>{
        // TODO: remove when defaultValue is removed from schema
        if (currentValue !== value) {
            _onChange(currentValue);
        }
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);
    // Sync with parent value while current value is falsy
    useEffect(()=>{
        if (value && !currentValue) {
            setCurrentValue(value);
        }
    }, [
        value,
        currentValue
    ]);
    const onChange = useCallback((newValue, selectedCountry)=>{
        const allowedCountry = allowedCountryCodes?.length === 1 ? allowedCountryCodes[0] : undefined;
        const country = selectedCountry || allowedCountry;
        const parsedValue = parseLocalPhone(newValue, country);
        setCurrentValue(newValue);
        _onChange(parsedValue);
    }, [
        _onChange,
        allowedCountryCodes
    ]);
    const invokeBlur = useInvokeCallback(onBlur);
    const handleBlur = useCallback(()=>{
        invokeBlur();
    }, [
        invokeBlur
    ]);
    const onSubmitSuccess = useCallback(()=>{
        setCurrentValue('');
        _onChange('');
    }, [
        _onChange
    ]);
    useSubmitSuccessEvent(onSubmitSuccess);
    return /*#__PURE__*/ React.createElement(FieldLayout, {
        fieldId: id,
        renderLabel: ()=>/*#__PURE__*/ React.createElement(FieldLabelWUT, {
                labelId: labelId,
                htmlFor: inputId,
                required: required,
                label: label,
                hideLabel: hideLabel,
                requiredIndicatorType: requiredIndicatorType,
                requiredIndicatorPlacement: requiredIndicatorPlacement
            }),
        renderInput: ()=>widgetHtml && widgetEnabled ? /*#__PURE__*/ React.createElement(Widget, {
                fieldId: id,
                widgetHtml: widgetHtml,
                onChange: _onChange,
                value: value
            }) : /*#__PURE__*/ React.createElement(PhoneInputWUT, {
                fieldId: id,
                inputId: inputId,
                hasError: hasError,
                value: currentValue ? currentValue : '',
                className: classNames(classes.textField, classes.theme, {
                    [classes.error]: hasError,
                    [classes.hover]: forcedHover
                }),
                onChange: onChange,
                required: required,
                disabled: disabled,
                placeholder: placeholder,
                onBlur: handleBlur,
                onFocus: onFocus,
                theme: TextFieldTheme.Box,
                ariaDescribedBy: ariaDescribedBy,
                ariaInvalid: hasError,
                showFlag: showFlag,
                defaultCountry: defaultCountry,
                allowedCountryCodes: allowedCountryCodes,
                readOnly: readOnly,
                ariaLabel: `${label}. ${t('field.phone.aria-label')}`
            }),
        renderDescription: ()=>/*#__PURE__*/ React.createElement(React.Fragment, null, /*#__PURE__*/ React.createElement(FieldErrorWUT, {
                target: target,
                hasError: hasError,
                errorMessage: errorMessage,
                id: errorId
            }), /*#__PURE__*/ React.createElement(FieldDescriptionWUT, {
                description: description,
                id: descriptionId
            }))
    });
};

//# sourceMappingURL=phone-input-field-wut.js.map